import { connect } from 'react-redux'
import requestRemoveUserFromCard from '../../sagas/requestRemoveUserFromCard'
import requestMakeUserResponsible from '../../sagas/requestMakeUserResponsible'
import User from './User'

export default connect(
  null,
  {
    requestRemoveUserFromCard,
    requestMakeUserResponsible
  }
)(User)

